/**
 * 签约引导至 APP 操作的弹窗
 * */
import React, { PureComponent } from 'react';
import './ModalDownQR.scss';
import { QRCodeCanvas } from 'qrcode.react';
import { Modal } from 'antd';
import { withRouter } from '../../WithRouterHOC';
import { connect } from 'react-redux';
import WEBIM from '../../../store/WebNim';

class ModalDownQR extends PureComponent {
  state = {
    visible: false,
    desc: '使用带带APР完成认证',
  };
  componentDidMount() {
    WEBIM.onConfigFn('OPEN_REAL_MODAL', this.showModal);
  }

  /**
   * 打开下载移动端二维码
   * @param {string} desc 二维码提示语
   * @param {boolean} isShowTip 风控用户展示实名认证二次确认弹窗
   * @param {number} type  0：防沉迷 1: 实名认证 2: 人脸识别
   * */
  showModal = (
    desc,
    isShowTip = false,
    type = 1,
    confirmContentText = null
  ) => {
    desc = desc || '使用带带APР完成认证';
    let textAlign = 'center';
    if (isShowTip) {
      if (type === 2) {
        desc = '使用带带APР完成人脸识别';
      }
      if (confirmContentText == null) {
        textAlign = 'left';
        confirmContentText =
          '检测到您的账号可能存在安全风险，需进行账号人脸认证，确保账号是您本人操作，防止账号被非法盗用及违规使用。';
      }

      Modal.confirm({
        title: '实名认证',
        icon: null,
        closable: true,
        content: (
          <>
            <div className={`real-tip-icon real-tip-icon-${type}`} />
            <p className={`real-tip-txt ${textAlign}`}>{confirmContentText}</p>
          </>
        ),
        className: 'real-tip-wrap daidai-confirm-style',
        cancelText: '残忍拒绝',
        okText: '去实名',
        centered: true,
        onOk: () => {
          if (type === 0) {
            WEBIM.events['OPEN_ADDICTION_VERIFIED'] &&
              WEBIM.events['OPEN_ADDICTION_VERIFIED']();
          } else {
            this.setState({ visible: true, desc });
          }
        },
      });
    } else {
      this.setState({ visible: true, desc });
    }
  };

  hideModal = () => {
    this.setState({ visible: false });
  };

  render() {
    const { base } = this.props;
    const { visible, desc } = this.state;
    return (
      <Modal
        open={visible}
        width={'400px'}
        className="daidai-modal-style has-top-border download-sing-up-modal"
        title="扫码下载"
        centered={true}
        keyboard={false}
        onCancel={this.hideModal}
        footer={null}
        maskClosable={false}
        zIndex={9999}
      >
        <div style={{ padding: '30px' }}>
          <p className="tip-text">{desc}</p>
          <div className="download-qr">
            <QRCodeCanvas
              value={`${base.rootConfig.mobilePath}?channelId=${base.channelId}`}
              imageSettings={{
                src: `/assets/img/logo-100.png`,
                width: 52,
                height: 52,
              }}
              size={212}
              bgColor={'#FFFFFF'}
              fgColor={'#000000'}
              level="M"
            />
          </div>
        </div>
      </Modal>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(ModalDownQR, { withRef: true })
);
